import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { TendencyContent, TendencyDown, TendencyUp } from './Tendency.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import Tooltip from '@components/Tooltips/Tooltip';
import fixedNumber from '@utils/fixedNumber';

interface IProps { tendencyUp?: boolean, studentId?: string, courseId?: string, kohortId?: string }

export const Tendency = (props: IProps) => {
  const { client, filterDate, systemSettings, settings } = useStore();
  const i18n = useI18n();
  const [tendency, setTendency] = useState(null)
  const id = useRef(null)
  let s3 = systemSettings?.find(s => s.APP_Setting_ID === 78)

  useEffect(() => {
    if (id.current !== null && (props.studentId === id.current || props.courseId === id.current || props.kohortId === id.current)) return
    getTrend(props.courseId, props.studentId, props.kohortId)
  }, [props.studentId, props.courseId, props.kohortId])

  const getTrend = async (courseId, studentId, kohortId) => {
    if (courseId) {
      id.current = courseId
    }
    else if (studentId) id.current = studentId
    else if (kohortId) id.current = kohortId

    if ((studentId && courseId)) {
      let t = await db.GetTrend(s3.value, courseId, studentId, filterDate.from, filterDate.to)
      if (t?.length > 0) setTendency(t[0])
    }
  }

  return (<>
    <TendencyContent>
      {fixedNumber(tendency?.trend, true) > 0 ?
        <Tooltip content={(i18n.t(settings.SHOWPRESENCE ? "tendency-up1-attendance" : "tendency-up1") + " " + fixedNumber(tendency?.trend, true) + i18n.t("tendency-up2", { count: s3.value })).replace("-", "")}>
          <TendencyUp showPresence={settings.SHOWPRESENCE} />
        </Tooltip>
        :
        fixedNumber(tendency?.trend, true) < 0 ? <Tooltip content={(i18n.t(settings.SHOWPRESENCE ? "tendency-down1-attendance" : "tendency-down1") + " " + fixedNumber(tendency?.trend, true) + i18n.t("tendency-down2", { count: s3.value })).replace("-", "")}>
          <TendencyDown showPresence={settings.SHOWPRESENCE} />
        </Tooltip> : tendency === null ? "" : <Tooltip content={i18n.t("tendency-none") + " " + i18n.t("tendency-down2", { count: s3.value })}>
          {"-"}
        </Tooltip>
      }
    </TendencyContent>
  </>);
};

export default Tendency;
